<template>
	<div>
		<CModal
			title="Liste des colis corrigés"
			size="lg"
			:show.sync="showModal"
			v-if="Object.values(creditNote).length > 0">
			<GDataTableRemote
				ref="mainTable"
				:remote-url="`${creditNote['@id']}/items`"
				:fields="fields"
				:items-per-page="10"
				hover
				striped
				sorter
				columnFilter
				pagination>
				<template #type="{ item }">
					<td>
						<CBadge :color="typeColor[item.type]">{{ typeTranslation[item.type] }}</CBadge>
					</td>
				</template>

				<template #actions="{ item }">
					<td class="text-center">
						<a href="#" @click.prevent="removeItem(item)">
							<CIcon name="cil-trash" />
						</a>
					</td>
				</template>
			</GDataTableRemote>

			<template #footer>
				<CButton color="secondary" v-on:click="showModal = false">Fermer</CButton>
				<CButton color="success" v-on:click="onAdd">Ajouter</CButton>
			</template>
		</CModal>

		<credit-notes-items-add ref="addModal" v-on:refresh="refresh" />
	</div>
</template>

<script>
	import GDataTableRemote from '@/components/ghostlexly-components/GDataTableRemote';
	import CreditNotesItemsAdd from '@/views/pages/points-of-sale/history/credit-notes/items/credit-notes-items-add';
	export default {
		name: 'credit-notes-items-list',
		components: { CreditNotesItemsAdd, GDataTableRemote },
		data() {
			return {
				showModal: false,
				creditNote: {},
				fields: [
					{ key: 'id', label: 'Identifiant unique' },
					{ key: 'name', label: 'Produit' },
					{ key: 'kgSupp', label: 'KG Supp.' },
					{ key: 'saleQty', label: 'Ventes' },
					{ key: 'depotQty', label: 'Dépôts' },
					{ key: 'type', label: 'Type' },
					{ key: 'total', label: 'Total (€)' },
					{ key: 'actions', label: 'Actions', filter: false, sorter: false },
				],
				typeColor: {
					'pos_credit_note_item.type.due': 'warning',
					'pos_credit_note_item.type.add': 'primary',
				},
				typeTranslation: {
					'pos_credit_note_item.type.due': 'Avoir',
					'pos_credit_note_item.type.add': 'Compl',
				},
			};
		},

		methods: {
			onAdd() {
				this.$refs.addModal.creditNote = this.creditNote;
				this.$refs.addModal.showModal = true;
			},

			refresh() {
				this.$refs.mainTable.refresh();
				this.$emit('refresh');
			},

			removeItem(item) {
				this.$axios.delete(item['@id']).then(() => {
					this.refresh();
				});
			},
		},
	};
</script>
